import { ADD_PERSISTENT_NOTIFICATION, REMOVE_PERSISTENT_NOTIFICATION } from '~/store/mutationTypes';

/** @type {import('@nuxt/types').Plugin} */
export default ({ store }, inject) => {
    /** @type {TIDAL.PersistentNotificationManager} */
    const manager = {
        info(content) {
            store.commit(ADD_PERSISTENT_NOTIFICATION, { type: 'info', text: content });
            return store.state.persistentNotificationsLastId;
        },
        remove(id) {
            store.commit(REMOVE_PERSISTENT_NOTIFICATION, id);
        },
    };

    inject('permanentNotification', manager);
};
